// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.arrow[data-v-3bbecbf6] \n{\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
